/* eslint-disable react/function-component-definition */
import React from 'react';
import PropTypes from 'prop-types';
import {
  GoogleMap,
  withScriptjs,
  withGoogleMap,
  Marker,
} from 'react-google-maps';
import { GOOGLE_MAP_KEY } from '../../../saas/AppStorageStaticNames';

const MapComponent = withScriptjs(
  withGoogleMap(({ lat, lng, name }) => (
    <GoogleMap defaultZoom={14} defaultCenter={{ lat, lng }}>
      <Marker position={{ lat, lng }} title={name} />
    </GoogleMap>
  )),
);

const HotelLocation = ({ lat, lng, name }) => {
  return (
    <div style={{ height: '400px', position: 'relative' }}>
      <MapComponent
        lat={lat}
        lng={lng}
        googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_KEY}&v=3.exp&libraries=geometry,drawing,places`}
        loadingElement={<div style={{ height: '100%' }} />}
        containerElement={<div style={{ height: '400px' }} />}
        mapElement={<div style={{ height: '100%' }} />}
        name={name}
      />
    </div>
  );
};

HotelLocation.propTypes = {
  lat: PropTypes.number.isRequired,
  lng: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
};

export default HotelLocation;
